<template>
	<div class="salary customerBox" ref="salary" :class="{addBottom:fixBtn}">
		<!-- start 薪资信息项设置 ---------------------------------------------------------------->
		<div class="customer-info">
			<div class="customer-info-item">
				<div class="customer-info-title">
					<!--图标-->
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-qiyexinxi" />
					</svg>
					<span>薪资项目设置</span>
				</div>
				<div class="customer-info-button">
					<el-switch v-model="showSys" active-text="显示系统分类"></el-switch>
				</div>
			</div>
			<!--start 薪资项目分类 ---------------------------------------------------------------->
			<draggable
			tag="div"
			:gutter="40"
			:list="form.lists"
			group="salaryItems"
			forceFallback="true"
			:options="{ghostClass:'ghostClass',fallbackClass:'fallbackClass'}"
			handle=".salaryItemHeaderL"
			@update="itemUpdate(form.lists)"
			>
				<div class="salaryItem" v-for="(list,index) in form.lists" :key="list.id">
					<el-row class="salaryItemHeader">
						<el-col class="salaryItemHeaderL" :span="4">{{list.name}}</el-col>
						<el-col class="salaryItemHeaderC" :span="16">{{list.remark}}</el-col>
						<!--自定义-->
						<el-col class="salaryItemHeaderR" :span="4">
							<!--编辑-->
							<div class="salaryCheck" v-if="!isSysItem(list)" @click="editType(index)">
								<el-tooltip class="item" effect="dark" content="编辑自定义名称" placement="top">
									<!--图标-->
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-xiugai" />
									</svg>
								</el-tooltip>
							</div>
							<!--可选目录-->
							<el-popover class="salaryCheck" :class="{salaryCheckActve:popVisible[index].visible}" popper-class="salaryCheckPop"
							 placement="bottom" width="120" v-loading="loading" visible-arrow="false" v-model="popVisible[index].visible">
								<div class="salaryCheckBox">
									<div class="salaryChecks">
										<el-checkbox-group v-model="checkedList[index]">
											<el-checkbox @change="changeItem(list,index)" v-for="list in checkLists[index].checkList" :label="list.itemNameCh"
											 :key="list.id" :title="list.itemNameCh"
											 :disabled="list.itemId =='EMP_NAME'||list.itemId =='ID_CARD'||list.itemId =='PAY_AMOUNT' ?'disabled':false">
											 <!-- 雇员姓名 证件号码	应发金额 不可取消-->
												 {{list.itemNameCh}}
											 </el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="addCheck" @click="addItem(index)">＋ 添加自定义项</div>
								</div>
								<el-tooltip class="item" effect="dark" content="添加薪资项" placement="top" slot="reference">
									<!--图标-->
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-zhanxianxingshi_A" />
									</svg>
								</el-tooltip>
							</el-popover>
							<!--删除-->
							<div class="salaryCheck" v-if="!isSysItem(list)" @click="deleteType(index)">
								<el-tooltip class="item" effect="dark" content="删除自定义项" placement="top">
									<!--图标-->
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-zhanxianxingshi_C" />
									</svg>
								</el-tooltip>
							</div>
							<!--展开-->
							<div class="salaryShow" v-if="opens[index].open" @click="changeOpen(index)">
								<el-tooltip class="item" effect="dark" content="展开" placement="top">
									<!--图标-->
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-zhankaizhuangtai" />
									</svg>
								</el-tooltip>
							</div>
							<!--收起-->
							<div class="salaryShow" v-else @click="changeOpen(index)">
								<el-tooltip class="item" effect="dark" content="收起" placement="top">
									<!--图标-->
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-shouqizhuangtai" />
									</svg>
								</el-tooltip>
							</div>
						</el-col>
					</el-row>
					<!--start 薪资项目   ---------------------------------------------------------------->
					<draggable
						tag="div"
						:list="list.wageItemList"
						class="salaryItemContent"
						:group="'setItem'+index"
						forceFallback="true"
						filter=".salaryBtn,.salaryFormula"
						:options="{ghostClass:'ghostClass',fallbackClass:'fallbackClass'}"
						v-show="opens[index].open"
						v-if="list.wageItemList"
						@update="itemUpdate(list.wageItemList)"
					 >
						<!-- <el-row
              class="salaryLine"
              v-for="(item,itemIndex) in list.wageItemBOList"
              :key="item.id"
              v-if="( item.fixed === 1&&showSys||item.fixed !== 1 ) && !item.isDelete"
            > -->
						<el-row class="salaryLine" v-for="(item,itemIndex) in list.wageItemList" :key="item.id" v-if="isSysItem(item)&&showSys||!isSysItem(item)">
							<el-col :span="4">
								<div class="salaryTitle">
									<el-tooltip content="系统项（不可编辑）" effect="dark" placement="top" v-if="isSysItem(item)">
										<svg class="icon" aria-hidden="true">
											<use xlink:href="#icon-xitongxiang" />
										</svg>
									</el-tooltip>
									<div v-else class="zhanwei"></div>
									<el-tooltip class="item" effect="dark" placement="top">
										<div slot="content">{{item.itemNameCh}}</div>
										<span>{{item.itemNameCh}}</span>
									</el-tooltip>
								</div>
							</el-col>
							<el-col :span="9">
								<div class="salaryExplain">
									<el-tooltip v-if="item.remark" placement="top">
										<div slot="content">{{item.remark}}</div>
										<p class="salaryExplain">{{item.remark}}</p>
									</el-tooltip>
									<div v-else>{{item.remark}}</div>
								</div>
							</el-col>
							<el-col :span="9">
								<div class="salaryFormula hasFormula" v-if=" item.isFormula =='10020002' || ( item.isFormula == '10020001' && item.wageFormula && item.wageFormula.formulaZh && item.wageFormula.formulaZh!='')">
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-shezhigongshi" />
									</svg>

									<span v-if="item.isFormula =='10020002'"></span>
									<span v-if="item.isFormula =='10020001'" @click="showFormulaDialog(index,itemIndex)">已设置：{{item.wageFormula.formulaZh}}</span>
									<!-- <span >固定项</span> -->
								</div>
								<div class="salaryFormula" v-else>
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-shezhigongshi" />
									</svg>
									<span @click="showFormulaDialog(index,itemIndex)">点击设置公式</span>
								</div>
							</el-col>
							<el-col :span="2">
								<div v-if="isSysItem(item) && (item.itemId=='PAY_AMOUNT' || item.itemId=='CUS_DEDUCTION_SALARY')">
									<div class="salaryBtn ">
										<!-- 支持修改的系统项 :
											应发金额
											税后应客户要求扣款
										-->
										<!--编辑-->
										<svg class="icon salaryBtnEdit" aria-hidden="true" @click="salaryEdit(index,itemIndex)">
											<use xlink:href="#icon-zhanxianxingshi_B" />
										</svg>
										<!--删除-->
										<div class="disabledBtn">
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-zhanxianxingshi_C" />
											</svg>
										</div>
									</div>
								</div>
								<div class="salaryBtn disabledBtn" v-else-if="isSysItem(item)">
									<!--编辑-->
									<!-- <svg  class="icon salaryBtnEdit" aria-hidden="true"  v-if="!isSysItem(item)" @click="salaryEdit(index,itemIndex)" > -->
									<svg class="icon salaryBtnEdit" aria-hidden="true">
										<use xlink:href="#icon-zhanxianxingshi_B" />
									</svg>
									<!--删除-->
									<svg class="icon" aria-hidden="true">
										<use xlink:href="#icon-zhanxianxingshi_C" />
									</svg>
								</div>
								<div class="salaryBtn" v-else>
									<!--编辑-->
									<!-- <svg  class="icon salaryBtnEdit" aria-hidden="true"  v-if="!isSysItem(item)" @click="salaryEdit(index,itemIndex)" > -->
									<svg class="icon salaryBtnEdit" aria-hidden="true" @click="salaryEdit(index,itemIndex)">
										<use xlink:href="#icon-zhanxianxingshi_B" />
									</svg>
									<!--删除-->
									<svg class="icon" aria-hidden="true" @click="deleteData(index,itemIndex)">
										<use xlink:href="#icon-zhanxianxingshi_C" />
									</svg>
								</div>
							</el-col>
						</el-row>
					</draggable>
					<!--end 薪资项目   ---------------------------------------------------------------->
				</div>
			</draggable>
		</div>
		<!-- end 薪资信息项设置 ---------------------------------------------------------------->
		<div class="addItem" @click="addType">
			<svg class="icon" aria-hidden="true">
				<use xlink:href="#icon-tianjiajihua" />
			</svg>
			<span>添加自定义分类</span>
		</div>
		<div class="marginTop30" :class="{fixBtn:fixBtn}" style="text-align: center">
			<el-button type="primary" @click="_saveTemplate">
				确定
			</el-button>
			<el-button @click="$router.back(-1)">
				取消
			</el-button>
		</div>


<!-- dialog--------------------------------------------------------------------------------- -->
		<el-dialog title="设置自定义项目" :visible.sync="dialogItem" @open="_disableItem" :close-on-click-modal="false"
		 :close-on-press-escape="false" width="30%" :before-close="handleClose" v-dialog-drag>
			<el-form :model="itemForm" ref="itemForm" :rules="customItemRules" class="editForm" label-width="120px"
			 >
				<el-row>
					<el-col :span="24">
						<el-form-item label="薪资项名称" prop="itemNameCh" >
							<el-input :disabled="disableItem" v-model="itemForm.itemNameCh" placeholder="请输入自定义项名称" />
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="薪资项英文名称" prop="itemNameEn">
							<el-input :disabled="disableItem" v-model="itemForm.itemNameEn" placeholder="请输入自定义项英文" />
						</el-form-item>
					</el-col>

					<el-col :span="24" v-show="false">
						<el-form-item label="顺序" prop="itemName">
							<el-input :disabled="disableItem" v-model="itemForm.seq" placeholder="请输入自定义项名称" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="是否公式项" prop="isFormula" >
							<el-radio-group v-model="itemForm.isFormula">
								<el-radio :label="'10020002'">固定项</el-radio>
								<el-radio :label="'10020001'">公式项</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-show="false">
						<el-form-item label="值是否为空" prop="valueNotNull" >
							<el-radio-group v-model="itemForm.valueNotNull">
								<el-radio :disabled="disableItem" :label="'10020002'">否</el-radio>
								<el-radio :disabled="disableItem" :label="'10020001'">是</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-show="false">
						<el-form-item label="是否必有" prop="mustRequire">
							<el-radio-group v-model="itemForm.mustRequire">
								<el-radio :disabled="disableItem" :label="'10020002'">否</el-radio>
								<el-radio :disabled="disableItem" :label="'10020001'">是</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-show="false">
						<el-form-item label="是否可编辑" prop="canModify">
							<el-radio-group v-model="itemForm.canModify">
								<el-radio :disabled="disableItem" :label="'10020002'">否</el-radio>
								<el-radio :disabled="disableItem" :label="'10020001'">是</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-show="false">
						<el-form-item label="是否显示" prop="isShow">
							<el-radio-group v-model="itemForm.isShow">
								<el-radio :label="'10020002'">否</el-radio>
								<el-radio :label="'10020001'">是</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="24">
						<el-form-item label="数据类型" prop="valueType">
							<el-select :disabled="disableItem" v-model="itemForm.valueType" placeholder="请选择">
								<el-option v-for="item in options" :key="item.codeItemId" :label="item.codeItemName" :value="item.codeItemId"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="24">
						<el-form-item  label="数据类型" prop="valueType" >
							<el-select :disabled="disableItem" v-model="itemForm.valueType" placeholder="请选择">
								<el-option
									v-for="item in  this.dicts.codeList[9242]"
									v-if="item.codeItemId!='92420014' && item.codeItemId!='92420011' && item.codeItemId!='92420010'
									&& item.codeItemId!='92420009' && item.codeItemId!='92420008' && item.codeItemId!='92420007'
									&& item.codeItemId!='92420005' "
									:key="item.codeItemId"
									:label="item.codeItemName"
									:value="item.codeItemId"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="项目描述" prop="remark">
							<el-input :disabled="disableItem" type="textarea" :rows="2" placeholder="请输入描述信息" maxlength="300"
							 show-word-limit v-model="itemForm.remark"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogItemSave">确 定</el-button>
				<el-button @click="dialogItemClose">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="添加自定义分类" :visible.sync="dialogType" width="30%"
							v-dialogDrag
							:close-on-click-modal="false"
							:close-on-press-escape="false" :before-close="handleClose">
			<el-form
				:model="typeForm"
				ref="typeForm"
				:rules="releaseRules"
				class="editForm"
				label-width="80px"
			>
				<el-row>
					<el-col :span="24">
						<el-form-item label="分类名称" prop="name" :rules="[{ required: true, message: '分类名称不能为空', trigger: 'blur' }]">
							<el-input v-model="typeForm.name" placeholder="请输入自定义分类名称" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="项目描述" prop="remark">
							<el-input
								type="textarea"
								:rows="2"
								placeholder="请输入描述信息"
								maxlength="300"
								show-word-limit
								v-model="typeForm.remark"
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogTypeSave">确 定</el-button>
				<el-button @click="dialogTypeClose">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="添加公式" class="dialogFormula" :visible.sync="dialogFormula" width="70%" :close-on-click-modal="false"
		 :close-on-press-escape="false" :before-close="handleClose" v-dialog-drag>
			<el-form :model="this.formulaInfo" ref="formulaInfo" :rules="releaseRules" class="editForm formulaInfo" label-width="160px">

				<el-row >
					<!-- <el-col>
						<el-form-item label="公式顺序" prop="seq"  class="elCol">
							<el-input v-model="formulaInfo.seq" />
						</el-form-item>
					</el-col> -->
					<el-col :span="24">
						<el-form-item label="公式" prop="formulaZh">
							<el-input id="formulaZh" v-model="formulaInfo.formulaZh" placeholder="请输入公式" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="运算符">
							<el-button size="mini" type="danger" v-for="item in this.formulaSymbolList " :key="item.codeItemId"
							@click="doOperate(item.codeItemName,item.codeItemName)">{{item.codeItemName}}</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="数字">
							<el-button size="mini" type="primary" @click="doOperate('0','0')">0</el-button>
							<el-button size="mini" type="primary" @click="doOperate('1','1')">1</el-button>
							<el-button size="mini" type="primary" @click="doOperate('2','2')">2</el-button>
							<el-button size="mini" type="primary" @click="doOperate('3','3')">3</el-button>
							<el-button size="mini" type="primary" @click="doOperate('4','4')">4</el-button>
							<el-button size="mini" type="primary" @click="doOperate('5','5')">5</el-button>
							<el-button size="mini" type="primary" @click="doOperate('6','6')">6</el-button>
							<el-button size="mini" type="primary" @click="doOperate('7','7')">7</el-button>
							<el-button size="mini" type="primary" @click="doOperate('8','8')">8</el-button>
							<el-button size="mini" type="primary" @click="doOperate('9','9')">9</el-button>
							<el-button size="mini" type="primary" @click="doOperate('.','.')">.</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="函数">
							<el-button size="mini" type="warning" v-for="item in this.formulaItemList " :key="item.codeItemId" @click="doOperate(item.codeItemName.replace('()','('),item.codeItemName.replace('()','('))">{{item.codeItemName}}</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="推荐项目">
							<el-button size="mini" type="primary"
							@click="doOperate('NETWORKDAYS([任职受雇日期],#所属月月底#)','NETWORKDAYS([任职受雇日期],#所属月月底#)')">入职天数</el-button>
							<el-button size="mini" type="primary"
							@click="doOperate('NETWORKDAYS(IF([任职受雇日期]<#所属月月初#,#所属月月初#,[任职受雇日期]),IF([离职日期]<#所属月月底#,[离职日期],#所属月月底#))','NETWORKDAYS(IF([任职受雇日期]<#所属月月初#,#所属月月初#,[任职受雇日期]),IF([离职日期]<#所属月月底#,[离职日期],#所属月月底#))')">本月工作天数</el-button>
						</el-form-item>
					</el-col>

					<!--<el-col :span="24">-->
						<!--<el-form-item v-for="item in this.form.lists" :key="item.id" :label="item.name">-->
							<!--<el-button v-for="item1 in item.wageItemList"-->
								<!--:key="item1.id"-->
								<!--size="mini"-->
								<!--type="info"-->
								<!--@click="doOperate('['+item1.itemNameCh+']',item1.itemId)">-->
								<!--{{item1.itemNameCh}}-->
							<!--</el-button>-->
						<!--</el-form-item>-->
					<!--</el-col>-->

				</el-row>
				<div class="rowContain">
						<el-row >


										<el-col :span="24">
											<el-form-item v-for="item in this.form.lists" :key="item.id" :label="item.name">
												<el-button v-for="item1 in item.wageItemList"
													:key="item1.id"
													size="mini"
													type="info"
													@click="doOperate('['+item1.itemNameCh+']',item1.itemId,item1)">
													{{item1.itemNameCh}}
												</el-button>
											</el-form-item>
										</el-col>
									</el-row>

				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveFormula()">确 定</el-button>
				<el-button @click="closeFormulaDialog">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	// import {getCodeItemList,getTemplateItemList,saveTemplate,checkTemplateName } from "@/api/biz/salaryTemplate";
	import {
		getCodeItemList,
		getTemplateItemList,
		saveTemplate,
		getColumnData,
		getTableData,
		checkItemName
	} from "@/api/wage/salaryTemplate";
	import {
		Message
	} from 'element-ui' //解决this.$message is not a function,手动导入Message
	import {
		mapGetters
	} from "vuex";
	import draggable from "vuedraggable";
  import {deepCopy} from '@/util/util';

  var loadingMatch;
	export default {

		computed: {
			...mapGetters([
				'dicts',
				'tenantInfo',
				'clientInfo'
			])
		},
		components: {
			draggable
		},
		data() {
			let validateName = (rule, value, callback) => {
				if (!value) {
					callback(new Error("模板名称不能为空"));
				}
				callback()
				//       checkTemplateName(value,this.cusId,this.templateId).then(res=>{
				//         let rs=res.data
				//         if(rs.code===0){
				//           if(rs.data){
				//             callback(new Error("模板名称已经存在"));
				//           }else{
				//             callback()
				//           }
				//         }else{
				//           this.$message.error('后台出现问题');
				//           callback()
				//         }
				//       })
			}

			return {
				name: "templateItem",
				loading: false,
				fixBtn: false,
				form: {
					id: this.$route.query.id, // 模板id
					templateName: "",
					remarks: "",
					level: 0, // 级别
					lists: []
				},

				// submitLoading: false, //禁用提交按钮
				dialogFormula: false, //是否显示公式设置对话框
				dialogItemOrder: false, // 模板项排序对话框
				dialogItem: false,
				dialogItemIndex: [],
				dialogTypeIndex: null,
				dialogType: false,
				popVisible: [], //下拉框是否显示
				opens: [], //是否收起
				showSys: true,
				disableItem: false,

				cusId: this.$route.query.cusId,
				templateId: this.$route.query.id,
				formula: "",
				formulaItemList: [], //公式列表
				formulaSymbolList: [], //算术符号列表
				formulaList: [],
				columnCodeList: [],
				usedColumnJson: {}, //该模板下所有的薪资项引用
				formulaInfo: {
					id: "",
					templateId: "",
					wageItemId: "",
					resultEnName: "",
					formulaZh: '', // 公式中文
					formulaEn: '', // 公式英文
					formulaBz: '', // 公式中文(标准名称)
					usedColumnArr: [], // 公式中使用的薪资项的columnCode
					seq: 1, // 顺序
					createId: "",
					bzCreateTime: "",
					tenantId: ""
				},

				checkLists: [], //模板候选项列表
				checkedList: [], // 已选

				hasCusWageSetCount: 0, //系统已存在的自定义分类个数
				addCusWageSetCount: 1, //新增的自定义分类个数

				availableColumnCodes: [], //可用的用户自定义项的字段名
				availableEmpColumnCodes: [], //可用的雇员自定义项的字段名

				typeForm: {
					id: "",
					setName: "", //薪资集名称
					remark: "", // 备注
					showOrder: "", // 顺序
					wageItemList: [] //薪资项列表
				},
				itemForm: {
					id: "",
					itemNameCh: "", //模板项名称
					itemNameEn: "", // 模板项英文名
					valueType: "", //值类型，代码集
					valueNotNull: "", //值是否为空
					mustRequire: "", //是否必有
					canModify: "", //是否可编辑
					isFormula: "", //是否是公式项
					isShow: "", //是否显示
					codeSetId: "", // 代码集ID
					columnCode: "", //数据库字段
					dataSource: "", // 数据来源
					dataSourceTable: "", // 数据来源项表
					dataSourceItemId: "", //数据来源项
					formulaId: "", //公式Id
					formulaZh: "", //中文公式
					formulaZh: "", //英文公式
					remark: ""
				},
				options: [{
						codeItemId: '1',
						codeItemName: '整数'
					},
					{
						codeItemId: '2',
						codeItemName: '小数'
					},
					{
						codeItemId: '3',
						codeItemName: '文本'
					},
					{
						codeItemId: '6',
						codeItemName: '代码值'
					},
				], //项目类型代码集
				additemType: '添加自定义分类',
				rules: {
					templateName: [{
							required: true,
							message: "请输入模板名称",
							trigger: "blur"
						},
						{
							min: 4,
							max: 40,
							message: "长度在 4 到 40 个字符",
							trigger: "blur"
						},
						{
							validator: validateName,
							trigger: 'blur'
						}
					],
					remarks: [{
						max: 100,
						message: "长度不能大于100",
						trigger: "blur"
					}]
				},
				customItemRules: {
					itemNameCh: [{ required: true, validator:this.checkItemName, trigger: 'blur' }],
					isFormula:[{ required: true, message: '是否公式项不能为空', trigger: 'blur' }],
					valueType: [{ required: true, message: '数据类型不能为空', trigger: 'blur' }]
				},
				oldItemNameCh:'',
				tempSaveName:[]
			};
		},
		updated() {
			this.$nextTick(() => {
				this.isFixBtn()
			})
		},
		created() {
			this.init();
			this.getFormlaItem();
			this.getFormlaSymbol();
			this.getValueTypeCodes()
		},
		methods: {
		   init() {
		        // 获取信息
		        let templateId=this.$route.query.id
		        getTemplateItemList(templateId).then((res) => {

		          let rs=res.data.data
		          // 模板基础信息
		          let template=rs.templateInfo

		          this.form.templateName=template.templateName
		          //this.form.remarks= template.remarks
		          // 模板项列表
		          this.form.lists = template.lists;
		          // 模板候选项列表
		          this.checkLists=rs.checkLists
		          const len = this.form.lists.length;
		          for (var i = 0; i < len; i++) {
		            this.popVisible.push({ visible: false });
		            this.opens.push({ open: true });
		          }
		          this.form.lists.forEach(value=>{
		            let arr=new Array()
		            if(value.wageItemList!=null){
		              value.wageItemList.forEach(value=>{
		                arr.push(value.itemNameCh)
		                // if(value.isFormula=='10020001'){
		                //     this.formulaList.push(value.wageFormula)
		                // }
		              })
		            }

		            this.checkedList.push(arr)
		          })

							//模板自定义项
							this.availableColumnCodes=rs.customColumnCodes
							//雇员自定义项
		          this.availableEmpColumnCodes=rs.customEmpColumnCodes

		        });
		      },
			// 获取模板项数据类型
			getValueTypeCodes: function() {
				getCodeItemList('9242').then(res => {
					let rs = res.data
					if (rs.code == 0) {
						// this.options=
						let arr = rs.data.filter(value => {
							return value.codeItemId == '92420003'
						})
						let arr1 = rs.data.filter(value => {
							return value.codeItemId == '92420001'
						})
						arr[0].codeItemName = '数值'
						arr.push(arr1[0])
						this.options = arr
					} else {
						this.$message.error('获取值类型出现问题')
					}
				})
			},
			// 是否固定按钮
			isFixBtn() {
				// 获取组件高度
				let height = this.$refs.salary.clientHeight;
				//获取组件父级高度
				let parentHeight = window.innerHeight - 65;
				if (height > parentHeight) {
					this.fixBtn = true;
				}
			},
			//保存模板
      _saveTemplate() {
        // 保存前重算所有公式项的 formulaBz，修复历史数据为空的情况
        if (!this.rebuildFormulaBz()) {
          return;
        }

        loadingMatch = this.$loading({ target: ".main" });
        this.disableSubmit = true;
        saveTemplate(this.form).then(res => {
          loadingMatch.close();
          let rs = res.data;
          if (rs.code == 0) {
            this.$message.success('提交成功');
            this.init();
            // this.$router.back(-1)
          }
          this.disableSubmit = false;
        });
      },

      // 保存前重算公式项的标准名称 formulaBz
      rebuildFormulaBz() {
        for (let i in this.form.lists) {
          let itemSet = this.form.lists[i];
          if (!itemSet.wageItemList) continue;

          for (let j in itemSet.wageItemList) {
            let item = itemSet.wageItemList[j];
            let wf = item.wageFormula;
            // 只处理有中文公式的项
            if (!wf || !wf.formulaZh) continue;

            // 复用 getSysName，与 saveFormula 中 transFormulaInfo 的算法保持一致
            let bz = this.getSysName(wf.formulaZh);
            if (bz === null) {
              // getSysName 内部已 this.$message.error 提示具体是哪一项
              return false;
            }
            this.$set(wf, 'formulaBz', bz);
          }
        }
        return true;
      },
			changeOpen(index) {
				this.$set(this.opens[index], "open", !this.opens[index].open);
			},
			// 选择模板项候选项
// 			changeItem(checked, index) {
// 				let arr = this.checkedList[index]
// 				if (arr.includes(checked.columnCode)) {
// 					this.form.lists[index].wageItemList.push(checked)
// 				} else {
// 					let newArr = this.form.lists[index].wageItemList.filter((value) => {
// 						return value.columnCode !== checked.columnCode
// 					})
// 					this.$set(this.form.lists[index], 'wageItemList', newArr)
// 				}
// 			},
			changeItem(checked,index) {

				let arr=this.checkedList[index]

				// checked.isFormula = "10020002"; // 是否公式项：否
				// debugger
				if(arr.includes(checked.itemNameCh)){
					this.form.lists[index].wageItemList.push(checked)
				}else{
					let newArr=this.form.lists[index].wageItemList.filter((value)=>{return value.itemNameCh!==checked.itemNameCh})
					this.$set(this.form.lists[index],'wageItemList',newArr)
				}
			},
			// 新增行
			addItem(index) {
				if(this.$refs.itemForm){
					this.$refs['itemForm'].clearValidate();
				}
				this.dialogItem = true;
				this.oldItemNameCh = '';
				let itemIndex = 0; //薪资项数量
				let wageSet = this.form.lists[index] //薪资集
				if (null != wageSet.wageItemList) {
					itemIndex = wageSet.wageItemList.length
				} else {
					wageSet.wageItemList = []
				}
				this.dialogItemIndex = [index, itemIndex];
				// 对应数据置为空
				this.itemForm.id = null;
				this.itemForm.itemNameCh = "";
				if (itemIndex == 0) {
					this.itemForm.seq = 1
				} else {
					// 去最后一个元素的顺序加1
					let lastSeq = wageSet.wageItemList[itemIndex - 1].seq
					this.itemForm.seq = new Number(lastSeq) + 1
				}
				this.itemForm.id = ""
				this.itemForm.itemId = ""
				this.itemForm.valueType = ""; //默认
				this.itemForm.itemNameEn = "" //模板项英文名
				this.itemForm.itemNameCh = "" //模板项名称
				this.itemForm.itemCreateType = "92460002" //自定义项
				this.itemForm.valueNotNull = "10020002"; //值不能为空： 否
				this.itemForm.mustRequire = "10020002"; // 是否必有： 否
				this.itemForm.canModify = "10020001"; // 是否可编辑： 是
				this.itemForm.isFormula = "10020002"; // 是否公式项：否
				this.itemForm.isShow = "10020001"; // 是否显示：否
				this.itemForm.codeSetId = this.form.lists[index].id?this.form.lists[index].id:'';
				this.itemForm.columnCode = "";
				this.itemForm.dataSource = "30380001"; // 数据来源：导入
				this.itemForm.dataSourceTable = "";
				this.itemForm.dataSourceItemId = "";
				this.itemForm.cusId = this.cusId
				this.itemForm.remark = "";
				this.itemForm.tenantId = this.tenantInfo.tenantId // 租户ID
			},
			// 编辑行
			salaryEdit(index, itemIndex) {
				if(this.$refs.itemForm){
					this.$refs['itemForm'].clearValidate();
				}
				if(this.form.lists[index].wageItemList[itemIndex].itemCreateType=='92460002'){
					this.cusState=true;
				}else{
					this.cusState=false;
				}
				this.oldItemNameCh = this.form.lists[index].wageItemList[itemIndex].itemNameCh;
				let itemCreateType=this.form.lists[index].wageItemList[itemIndex].itemCreateType
				this.$set(this.itemForm, "id", this.form.lists[index].wageItemList[itemIndex].id);
				this.$set( this.itemForm,"itemNameCh",this.form.lists[index].wageItemList[itemIndex].itemNameCh);
				this.$set( this.itemForm,"itemNameEn",this.form.lists[index].wageItemList[itemIndex].itemNameEn);
				this.$set( this.itemForm,"valueType",this.form.lists[index].wageItemList[itemIndex].valueType);
				this.$set( this.itemForm,"valueNotNull",this.form.lists[index].wageItemList[itemIndex].valueNotNull);
				this.$set( this.itemForm,"mustRequire",this.form.lists[index].wageItemList[itemIndex].mustRequire);
				this.$set( this.itemForm,"canModify",this.form.lists[index].wageItemList[itemIndex].canModify);
				this.$set( this.itemForm,"itemCreateType",this.form.lists[index].wageItemList[itemIndex].itemCreateType);
				this.$set( this.itemForm,"isFormula",this.form.lists[index].wageItemList[itemIndex].isFormula);
				this.$set( this.itemForm,"isShow",this.form.lists[index].wageItemList[itemIndex].isShow);
				this.$set( this.itemForm,"codeSetId",this.form.lists[index].wageItemList[itemIndex].codeSetId);
				this.$set( this.itemForm,"itemId",this.form.lists[index].wageItemList[itemIndex].itemId);
				this.$set( this.itemForm,"dataSource",this.form.lists[index].wageItemList[itemIndex].dataSource);
				this.$set( this.itemForm,"dataSourceTable",this.form.lists[index].wageItemList[itemIndex].dataSourceTable);
				this.$set( this.itemForm,"dataSourceItemId",this.form.lists[index].wageItemList[itemIndex].dataSourceItemId);
				// this.$set(this.itemForm,"formulaZh",this.form.lists[index].wageItemList[itemIndex].formulaZh);
				// this.$set(this.itemForm,"formulaEn",this.form.lists[index].wageItemList[itemIndex].formulaEn);
				this.$set(this.itemForm,"remark",this.form.lists[index].wageItemList[itemIndex].remark);
				this.$set(this.itemForm,"wageFormula",this.form.lists[index].wageItemList[itemIndex].wageFormula);
				this.$set(this.itemForm,"seq",this.form.lists[index].wageItemList[itemIndex].seq);
				this.$set(this.itemForm,"branchId",this.form.lists[index].wageItemList[itemIndex].branchId);

				this.dialogItem = true
				this.dialogItemIndex = [index,itemIndex]
			},
		    // 保存一行
			dialogItemSave() {
				this.$refs['itemForm'].validate(valid=>{
					if(valid){
						// 保存
						let [index, itemIndex] = this.dialogItemIndex;
						let data = {};
						data.id = this.itemForm.id;
						data.cusId = this.cusId;
						data.itemNameCh = this.itemForm.itemNameCh;
						data.itemNameEn = this.itemForm.itemNameEn;
						data.valueType = this.itemForm.valueType;
						data.valueNotNull = this.itemForm.valueNotNull;
						data.mustRequire = this.itemForm.mustRequire;
						data.canModify = this.itemForm.canModify;
						data.isFormula = this.itemForm.isFormula;
						data.itemCreateType = this.itemForm.itemCreateType;
						data.isShow = this.itemForm.isShow;
						data.codeSetId = this.itemForm.codeSetId;
						//data.columnCode = this.itemForm.columnCode;
						data.dataSource = this.itemForm.dataSource;
						data.dataSourceTable = this.itemForm.dataSourceTable;
						data.dataSourceItemId = this.itemForm.dataSourceItemId;
						data.remark = this.itemForm.remark;
						data.seq = this.itemForm.seq
						data.wageFormula=this.itemForm.wageFormula
						data.branchId=this.itemForm.branchId

						if(this.form.lists[index].name =='雇员信息'){
							//雇员信息set 取雇员自定义项
							data.itemId = this.itemForm.itemId&&this.itemForm.itemId!=''?this.itemForm.itemId:this.availableEmpColumnCodes.pop()
						}else{
							//非雇员信息set 取模板自定义项
							data.itemId = this.itemForm.itemId&&this.itemForm.itemId!=''?this.itemForm.itemId:this.availableColumnCodes.pop()
						}

						//判断是否有自定义项的ItemID以供使用
						if(data.itemId==''||(!data.itemId)){
							this.$message.warning("没有足够的自定义项库存")
							return;
						}
						let temp=this.checkLists[index].checkList.filter(value=>{return value.itemNameCh==data.itemNameCh})
						this.$set(this.form.lists[index].wageItemList, itemIndex, data);	//模板项目列表
						this.$refs['itemForm'].resetFields();
						this.dialogItem = false;
						if(temp.length==0){
							this.checkLists[index].checkList.push(data)			//候选项列表
							this.checkedList[index].push(data.itemNameCh)		//已选项列表
						}
						this.tempSaveName.push(data.itemNameCh)
					}
				})
			},

			// 删除一行
			deleteData(index, indexItem) {
				let itemId=this.form.lists[index].wageItemList[indexItem].itemId
				let id=this.form.lists[index].wageItemList[indexItem].id
				if(id==""){
					//只对新增的自定义项 做的处理 归还ItemId 在候选列表中清除

					for (let i in this.checkLists[index].checkList) {//候选项列表
						let check = this.checkLists[index].checkList[i];
						if(check.itemId == itemId){
							this.checkLists[index].checkList.splice(i,1);
							break;
						}
					}
					//区分雇员set和非雇员set
					if(this.form.lists[index].name=='雇员信息'){
						this.availableEmpColumnCodes.push(itemId);
					}else{
						this.availableColumnCodes.push(itemId)
					}
				}
				this.form.lists[index].wageItemList.splice(indexItem, 1);	//模板项目列表
				this.checkedList[index].splice(indexItem, 1)							//已选项列表

			},

			//新增分类
			addType() {
				if(this.$refs['typeForm']){
					this.$refs['typeForm'].clearValidate();
				}
				if (this.hasCusWageSetCount + this.addCusWageSetCount > 5) {
					this.$message.error('单个客户最多只能创建5个自定义分类');
				} else {
					this.additemType = "添加自定义分类";
					this.dialogType = true;
					this.dialogTypeIndex = this.form.lists.length;
				}
			},


		      // 保存分类
		      dialogTypeSave() {
				this.$refs['typeForm'].validate((valid) =>{
					if(valid){
						let index = this.dialogTypeIndex;
						let data = {};
						data.id = this.typeForm.id;
						data.name = this.typeForm.name;
						data.seq = this.form.lists.length+1;
						data.itemCreateType= this.itemCreateType
						data.remark = this.typeForm.remark;
						data.wageItemList = this.typeForm.wageItemList;
						if (!(data.wageItemList instanceof Array)) {
						data.wageItemList = new Array();
						}
						this.$set(this.form.lists, index, data);
						const checkList ={
						id: JSON.stringify(index),
						checkList:[]
						}
						this.$set(this.checkLists,index,checkList)
						// debugger
						this.$set(this.popVisible, index, { visible: false });
						this.$set(this.opens, index, { open: true });
						this.$refs['typeForm'].resetFields();
						this.dialogType = false;
					}
				})
		      },

		      // 删除类别
		      deleteType(index) {
		        this.form.lists.splice(index,1)
		        // 删除该索引下的候选项列表
		        this.checkLists.splice(index,1)
		        // 删除该索引下已选择的候选项列表
		        this.checkedList.splice(index,1)
		      },
		      // 编辑类别
		      editType(index) {

		        this.dialogType = true;
						this.$set(this.typeForm, "id", this.form.lists[index].id);
		        this.$set(this.typeForm, "name", this.form.lists[index].name);
		        this.$set(this.typeForm, "remark", this.form.lists[index].remark);
		        // this.$set(this.typeForm, "self", this.form.lists[index].self);
		        this.$set(this.typeForm, "wageItemList", this.form.lists[index].wageItemList);
		        this.dialogTypeIndex = index;
		      },
			closeFormulaDialog: function() {
				this.dialogFormula = false
			},
			dialogItemClose() {
				this.$refs.itemForm.resetFields();
				this.dialogItem = false;
			},
			dialogTypeClose() {
				this.$refs.typeForm.resetFields();
				this.dialogType = false;
			},

			showFormulaDialog: function(index, itemIndex) {
				this.dialogItemIndex = [index, itemIndex]
				this.formulaInfo = {};

				let obj = this.form.lists[index].wageItemList[itemIndex].wageFormula

				if (obj) {
					this.formulaInfo = deepCopy(obj)
				}else{
					this.formulaInfo = this.form.lists[index].wageItemList[itemIndex]['wageFormula'] = {
						'resultEnName':this.form.lists[index].wageItemList[itemIndex].itemId
					}
				}

				this.dialogFormula = true
			},

			//保存公式
			saveFormula() {
				let [index, itemIndex] = this.dialogItemIndex
				//检查是否有多余[]
				let r = this.checkSymbol();
				if(!r){
					return;
				}
				//公式英文 不管之前怎么处理 再按中文重新翻译一遍
				this.transFormulaInfo();
				if(this.formulaInfo.formulaEn == null){
					//有无法转换的公式项 则不允许保存
					return;
				}
				//检查是否有互相引用现象
				let r1 = this.checkUsed()
				if(!r1){
					return;
				}

				let formula = this.formulaInfo
				this.$set(this.form.lists[index].wageItemList[itemIndex], 'wageFormula', formula)
				this.formulaInfo = {
					id: "",
					templateId: "",
					wageItemId: "",
					resultEnName: "",
					formulaZh: '', // 公式中文
					formulaEn: '', // 公式英文
					formulaBz: '', // 公式中文(标准名称)
					usedColumnArr: [], // 公式中使用的薪资项的columnCode
					seq: 1, // 顺序
					createId: "",
					bzCreateTime: "",
					tenantId: ""
				}
				this.dialogFormula = false
			},
			checkUsed(){
				let formla = this.formulaInfo;
				let checkStr = formla.resultEnName;
				let checkFormla = formla.formulaEn;;

				for (let i in this.form.lists) {
					let list = this.form.lists[i];
					for (let k in list.wageItemList) {
						let wageItem = list.wageItemList[k];
						let temp = wageItem.wageFormula
						if(temp && temp.formulaEn && temp.formulaEn!=''){
							let index = checkFormla.indexOf(temp.resultEnName);
							let index2 = temp.formulaEn.indexOf(checkStr);
							if(index != -1 && index2!= -1 ){
								debugger
								this.$message.warning('该公式与薪资项<'+wageItem.itemNameCh+'>存在互相引用,请仔细检查!')
								return false;
							}
						}
					}
				}
				return true;
			},
			checkSymbol(){
				let begin = this.formulaInfo.formulaZh.split('[');
				let end = this.formulaInfo.formulaZh.split(']');

				if(!begin && !end){
					return true;
				}else if(begin.length==end.length){
					return true;
				}else{
					this.$message.warning('公式中缺少或者多配置了一个“[”或“]”,请仔细检查！');
					return false;
				}
			},
			//递归翻译公式
			transFormulaInfo(){
				let fzh = this.formulaInfo.formulaZh
				let fen = this.getEnName(fzh);
				let fenBz = this.getSysName(fzh);
				fen = fen.replace(/×/g,'*')//替换所有×为*
				fen = fen.replace(/÷/g,'/')//替换所有÷为/
				this.formulaInfo.formulaEn = fen;
				this.formulaInfo.formulaBz = fenBz;
			},
			getEnName(fzh){
				let begin = fzh.indexOf('[')
				let end = fzh.indexOf(']')
				if(begin != -1){
					let word = ''
					word = fzh.substring(begin+1,end)
					let k = false;
					for (let i in this.form.lists) {
						let itemSet = this.form.lists[i]
						for (let j in itemSet.wageItemList) {
								let item = itemSet.wageItemList[j];
								if(word == item.itemNameCh){
									word = item.itemId
									if(item.valueType == '92420001' || item.valueType == '92420002'){//整数 小数 类型的数据加IFNULL
										word = "IFNULL("+word+",0)";
									}
									fzh = fzh.substring(0,fzh.indexOf('['))+word+fzh.substring(fzh.indexOf(']')+1,fzh.length);
									k=true;
									break;
								}
						}
						if(k){
							break;
						}
					}
					if(!k){
						this.$message.error('公式项转换无效,请仔细检查:['+word+']')
						return null;
					}
					fzh = this.getEnName(fzh)
				}

				return fzh;
			},

      getSysName(fzh){
        let errWord = null
        let result = fzh.replace(/\[([^\]]+)\]/g, (match, word) => {
          let target = null
          for (let i in this.form.lists) {
            let itemSet = this.form.lists[i]
            for (let j in itemSet.wageItemList) {
              let item = itemSet.wageItemList[j]
              if(word == item.itemNameCh){
                target = item.sysItemName || item.itemNameCh
                break
              }
            }
            if(target != null){
              break
            }
          }
          if(target == null){
            errWord = word
            return match
          }
          return '[' + target + ']'   // 保留中括号
        })

        if(errWord != null){
          this.$message.error('公式项转换无效,请仔细检查:[' + errWord + ']')
          return null
        }
        return result
      },


			insertInputTxt(insertTxt) {
				var elInput = document.getElementById("formulaZh");
				var startPos = elInput.selectionStart;
				var endPos = elInput.selectionEnd;
				if (startPos === undefined || endPos === undefined) return
				var txt = elInput.value;
				var result = txt.substring(0, startPos) + insertTxt + txt.substring(endPos)
				elInput.value = result;
				elInput.focus();
				elInput.selectionStart = startPos + insertTxt.length;
				elInput.selectionEnd = startPos + insertTxt.length;

				this.$set(this.formulaInfo, 'formulaZh', result)//给中文公式赋值
			},

			doOperate(value1, value2,item1) {
				let [index, itemIndex] = this.dialogItemIndex
				//函数项特殊处理
				switch(value1){
					case'if' :value1 = value2 = 'IF(,,)'
					break;
					case'round' : value1 = value2 = 'ROUND(number1 , number2)'
					break;
					case'DATEDIFF' : value1 = value2 = 'DATEDIFF(开始日期薪资项,开始日期薪资项,\'返回类型\')'
					break;
					case'NETWORKDAYS(' : value1 = value2 = 'NETWORKDAYS(开始日期薪资项,#所属月月底#)'
					break;
				}

				let columnCode = this.form.lists[index].wageItemList[itemIndex].columnCode
				if (value1 === "C") {//清空
					this.$set(this.formulaInfo, 'formulaZh', "")
					this.$set(this.formulaInfo, 'formulaEn', "")

					if (this.formulaInfo.usedColumnArr) {
						this.formulaInfo.usedColumnArr.forEach(value => {
							// debugger
							if (this.usedColumnJson.hasOwnProperty(value)) {
								let usedCount = Object.keys(this.usedColumnJson).map(e => this.usedColumnJson[value])
								if (usedCount > 0) {
									this.$set(this.usedColumnJson, value, new Number(usedCount) - 1)
								} else {
									this.$delete(this.usedColumnJson, value)
								}
							}
						})
					}
					this.formulaInfo.usedColumnArr = []
				} else {
					//光标处插入
					this.insertInputTxt(value1)

					if (this.columnCodeList.find(val => val === value2)) {
						this.formulaInfo.usedColumnArr.push(value2) //记录该公式使用那些薪资项
						if (this.usedColumnJson.hasOwnProperty(value2)) {
							let usedCount = Object.keys(this.usedColumnJson).map(e => this.usedColumnJson[value2])
							this.$set(this.usedColumnJson, value2, new Number(usedCount) + 1)
						} else {
							this.$set(this.usedColumnJson, value2, 1)
						}
					}
          // this.$set(this.formulaInfo, 'formulaZh', this.formulaInfo.formulaZh + value1)
          // this.$set(this.formulaInfo, 'formulaEn', this.formulaInfo.formulaEn + value2)

				}
			},
			//获取函数项
			getFormlaItem() {
				getCodeItemList('9243').then(res => {
					let rs = res.data
					// debugger
					if (rs.code == 0) {
						this.formulaItemList = rs.data
					} else {
						this.$message.error('获取公式项出现问题')
					}
				})
			},
			// 当当前用户非sys时修改值类型选项
			changeValueTypes: function() {
				if (this.tenantInfo.tenantId != '0') {
					this.options = [{
							codeItemId: '1',
							codeItemName: '数值'
						},
						{
							codeItemId: '3',
							codeItemName: '文本'
						},
					]
				}
			},
			// 获取公式符号
			getFormlaSymbol() {
				getCodeItemList('9241').then(res => {
					let rs = res.data
					// debugger
					if (rs.code == 0) {
						this.formulaSymbolList = rs.data
					} else {
						this.$message.error('获取公式项出现问题')
					}
				})
			},
			// 判断模板项是否为系统级
			isSysItem: function(item) {
				if(item.itemCreateType==='92460001'){
					return true
				}else if(item.setType=='sys'){
					return true
				}else{
					return false
				}
			},

			// 禁用编辑模板项
			_disableItem: function() {
				let [index, itemIndex] = this.dialogItemIndex;
				let item = this.form.lists[index]
				if (null == item.wageItemList) {
					this.disableItem = false
					return
				}
				let cusId = item.wageItemList[itemIndex].cusId
				if (cusId == null) {
					this.disableItem = true
				} else {
					this.disableItem = false
				}
			},
			checkItemName(rule,value,callback){
				if(!value||value==''){
					callback('薪资项名称不能为空')
				}else if(this.oldItemNameCh==value){
					callback();
				}else{
					//查询是否重名
					for (let i in this.tempSaveName) {
						if(this.tempSaveName[i]==value){
							callback('薪资项名称重复');
							return;
						}
					}
					let obj = {'name':value,'id':this.itemForm.id};
					checkItemName(obj).then(res=>{
						if(res.data.data){
							callback();
						}else{
							callback('薪资项名称重复');
						}
					})
				}
			},
			itemUpdate(list){
				for (let i in list) {
					list[i].seq=i;
				}
			},
		}
	}
</script>
<style scoped>
	.rowContain{
		height: calc(70vh - 230px);
		overflow: auto;
	}
	.editForm .el-form-item{
		margin-bottom: 10px;
	}
	.editForm .el-button{
		margin-bottom: 0!important;
	}
	.disabledBtn {
		color: #687592 !important;
	}

	.disabledBtn svg {
		cursor: not-allowed !important;
	}

	.addBottom {
		padding-bottom: 80px !important;
		position: relative;
	}

	.fixBtn {
		tt-align: center;
		position: absolute;
		bottom: 0px;
		background: #ffffff;
		left: 15px;
		right: 22px;
		padding: 10px 0;
		border-top: 1px solid #eeeeee;
		z-index: 33;
	}

	.el-switch {
		margin-top: 0;
	}

	.salaryItem {
		padding: 0 20px;
	}

	.salaryItemHeader {
		display: flex;
		margin-top: 20px;
		background-color: #efefef;
		line-height: 40px;
		color: #999;
		font-size: 16px;
		padding-left: 34px;
		padding-right: 30px;
		display: flex;
		justify-content: space-between;
	}

	.salaryItemHeaderL {
		padding-left: 26px;
		white-space: nowrap;
	}

	.salaryItemHeaderR {
		display: flex;
		justify-content: flex-end;
		color: #bbbbbb;
	}

	.salaryCheck {
		margin-right: 25px;
		padding: 0 5px;
	}

	.salaryCheckActve {
		background-color: #fff;
	}

	.salaryLine {
		border-bottom: 1px solid #efefef;
		line-height: 40px;
		padding: 0 30px 0 34px;
	}

	.salaryLine svg {
		font-size: 16px;
	}

	.salaryTitle svg {
		margin-right: 10px;
	}

	.salaryTitle span {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.salaryTitle .zhanwei {
		width: 16px;
		height: 16px;
		margin-right: 10px;
	}

	.salaryTitle {
		color: #000000;
		font-size: 14px;
		display: flex;
		align-items: center;
	}

	.salaryTitle svg {
		color: #ff9600;
	}

	.salaryExplain {
		font-size: 12px;
		color: #999999;
		padding: 10px;
		line-height: 20px;
	}

	.salaryFormula {
		color: #008aff;
		font-size: 12px;
		cursor: pointer;
	}

	.hasFormula {
		color: #999999;
		cursor: auto;
	}

	.salaryFormula svg {
		margin-right: 10px;
		color: #008aff;
	}

	.hasFormula svg {
		color: #75cf00;
	}

	.salaryBtn {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		height: 40px;
		color: #008aff;
	}

	.salaryBtnEdit {
		margin-right: 30px;
	}

	.salaryBtn svg {
		cursor: pointer;
	}

	.salaryItemHeaderC {
		color: #999999;
		font-size: 12px;
	}

	.salaryItemHeaderR div {
		cursor: pointer;
		margin-right: 30px;
	}

	.salaryItemHeaderR div:last-child {
		margin-right: 0px;
	}

	.addItem {
		margin: 20px auto 0;
		width: 160px;
		height: 30px;
		background-color: #dddddd;
		border-radius: 20px;
		font-size: 12px;
		color: #008aff;
		align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.addItem svg {
		margin-right: 10px;
		font-size: 16px;
	}

	.salaryChecks {
		max-height: 300px;
		overflow-y: auto;
	}

	.salaryChecks>>>.el-checkbox {
		display: flex;
		align-items: center;
		margin-right: 0;
	}

	.salaryChecks>>>.el-checkbox__label {
		line-height: 26px;
		color: #000000;
		font-size: 14px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		width: 120px;
	}

	.salaryChecks>>>.el-checkbox__input {
		margin-top: 2px;
	}

	.addCheck {
		cursor: pointer;
		width: 120px;
		height: 30px;
		font-size: 12px;
		color: #008aff;
		background: #efefef;
		border-radius: 20px;
		text-align: center;
		line-height: 30px;
		margin: 10px auto 0;
	}

	.el-radio-group {
		margin: 0;
		height: 30px;
		display: flex;
		align-items: center;
	}
	.salaryCheckPop {
		width: 160px !important;
	}

	.salaryCheckPop .popper__arrow {
		display: none;
	}

	.salaryBtn i {
		padding: 5px;
	}

	.el-button {
		margin-bottom: 10px;
		margin-right: 10px!important;
	}
	.editForm >>> .el-form-item .el-form-item__content{
		height: auto;
	}
	.el-button+.el-button{
		margin-left: 0;
	}
	.dialogFormula .editForm{
		padding:20px;
		margin: 0;
		height: 70vh;
		overflow: auto;
		overflow-x: hidden;
	}
	.dialogFormula >>> .el-dialog__body{
		padding: 0;
	}
	.elCol{
	/* 	position: absolute;
    background: #fff;
    z-index: 10;
    width: 100%;
    left: 0; */
	}
</style>
